<template>
  <div class="main">
    <div v-if="step==='history'" class="systemUpgrade">
      <div class="systemUpgrade-main">
        <module-title :title="`${updateRecordPrpos.campusAppName}${updateRecordPrpos.versionCode}--${updateStatus===1? &quot;升级失败记录&quot;:&quot;未升级记录&quot;}`">
          <div class="right">
            <el-button type="primary" size="medium" @click="exportExcel">
              导出
            </el-button>
            <el-button type="primary" size="medium" icon="el-icon-arrow-left" @click="$emit('back')">
              返回
            </el-button>
          </div>
        </module-title>
        <div class="tip">
          <div class="info">
            区域：{{ updateRecordPrpos.areaName }}
          </div>
          <div class="info">
            学校：{{ updateRecordPrpos.schoolName }}
          </div>
          <div v-if="updateRecordPrpos.upgradeType===2" class="info">
            楼栋：{{ updateRecordPrpos.buildingName }}
          </div>
          <div v-if="updateRecordPrpos.upgradeType===2" class="info">
            教室：{{ updateRecordPrpos.roomName }}
          </div>
          <div v-if="updateRecordPrpos.upgradeType===1" class="info">
            年级：{{ updateRecordPrpos.gradeName }}
          </div>
          <div v-if="updateRecordPrpos.upgradeType===1" class="info">
            班级：{{ updateRecordPrpos.className }}
          </div>
        </div>
        <el-form
          ref="searchForm"
          :model="searchForm"
          :inline="true"
          label-position="right"
          label-width="100px"
        >
          <el-form-item label="设备编码：" prop="deviceNo">
            <el-input
              v-model="searchForm.deviceNo"
              :maxlength="30"
              name="deviceNo"
              placeholder="请输入设备编码"
              clearable
            />
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              size="medium"
              icon="el-icon-search"
              @click="handleSearchFilter"
            >
              查询
            </el-button>
          </el-form-item>
        </el-form>
        <div class="systemUpgrade-main-contain">
          <el-table
            v-loading="listLoading"
            :data="applicationList"
            highlight-current-row
            fit
            element-loading-text="Loading"
            class="list-table"
          >
            <el-table-column label="序号" type="index" align="center" width="55" />
            <el-table-column label="区域" prop="areaName" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.provinceName }}/{{ scope.row.cityName }}/{{ scope.row.areaName }}</span>
              </template>
            </el-table-column>
            <el-table-column label="学校" prop="schoolName" align="center" />
            <el-table-column v-if="updateRecordPrpos.upgradeType===2" label="楼栋" prop="buildingName" align="center" />
            <el-table-column v-if="updateRecordPrpos.upgradeType===2" label="教室号" prop="roomName" align="center" />
            <el-table-column v-if="updateRecordPrpos.upgradeType===1" label="年级" prop="gradeName" align="center" />
            <el-table-column v-if="updateRecordPrpos.upgradeType===1" label="班级" prop="className" align="center" />
            <el-table-column v-if="updateRecordPrpos.upgradeType===1" label="设备型号" prop="deviceModel" align="center" />
            <el-table-column v-if="updateRecordPrpos.upgradeType===1" label="系统版本" prop="deviceVersion" align="center" />
            <el-table-column label="设备编码" prop="deviceNo" align="center" />
            <el-table-column v-if="updateStatus===1" label="更新失败时间" prop="index" align="center" />
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {
  campusVersionsReleaseUnupgradeList,
  campusVersionsReleaseUpgradeList,
  campusVersionUnupgradeExport,
  campusVersionUpgradeExport
} from '@/api/systemMaintenance/upgradeManage/versionManage';

export default {
  name: 'SystemUpgrade',
  props: {
    updateRecordPrpos: {
      type: Object,
      required: true
    },
    typeCode: {
      type: String,
      default: ''
    },
    updateStatus: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      step: 'history',
      // 搜索表单
      searchForm: {
        deviceNo: ''
      },
      listLoading: false, // 表格刷新loading
      applicationList: []
    };
  },
  computed: {

  },
  mounted() {
    this.fetchApplicationList();
  },
  methods: {
    // 条件查询
    handleSearchFilter() {
      console.log(this.searchForm);
      this.fetchApplicationList();
    },
    resetInput(param) {
      console.log(param);
    },
    back() {
      this.step = 'history';
      this.fetchApplicationList();
    },
    // 导出
    exportExcel() {
      var option = {
        campusAppVersionId: this.updateRecordPrpos.campusAppVersionId,
        areaCode: this.updateRecordPrpos.areaCode,
        schoolCode: this.updateRecordPrpos.schoolCode,
        typeCode: this.typeCode,
        deviceNo: this.searchForm.deviceNo
      };
      // 区分到教室还是到班级
      if (this.updateRecordPrpos.upgradeType === 1) {
        option = { ...option, classCode: this.updateRecordPrpos.classCode, gradeCode: this.updateRecordPrpos.gradeCode };
      } else {
        option = { ...option, buildingId: this.updateRecordPrpos.buildingId, roomId: this.updateRecordPrpos.roomId };
      }
      if (this.updateStatus === 1) {
        window.location.href = campusVersionUpgradeExport({ ...option, upgradeStatus: 2 });
      } else {
        window.location.href = campusVersionUnupgradeExport(option);
      }
    },
    // 获取应用列表
    fetchApplicationList() {
      this.listLoading = true;
      var option = {
        campusAppVersionId: this.updateRecordPrpos.campusAppVersionId,
        areaCode: this.updateRecordPrpos.areaCode,
        schoolCode: this.updateRecordPrpos.schoolCode,
        typeCode: this.typeCode,
        deviceNo: this.searchForm.deviceNo
      };
      // 区分到教室还是到班级
      if (this.updateRecordPrpos.upgradeType === 1) {
        option = { ...option, classCode: this.updateRecordPrpos.classCode, gradeCode: this.updateRecordPrpos.gradeCode };
      } else {
        option = { ...option, buildingId: this.updateRecordPrpos.buildingId, roomId: this.updateRecordPrpos.roomId };
      }
      if (this.updateStatus === 1) {
        campusVersionsReleaseUpgradeList({ ...option, upgradeStatus: 2 })
          .then(result => {
            this.applicationList = result.data;
            this.searchForm.total = result.data.total;
            this.listLoading = false;
          })
          .catch(err => {
            console.log(err);
            this.listLoading = false;
            this.applicationList = [];
            this.searchForm.total = 0;
          });
      } else {
        campusVersionsReleaseUnupgradeList(option)
          .then(result => {
            this.applicationList = result.data;
            this.searchForm.total = result.data.total;
            this.listLoading = false;
          })
          .catch(err => {
            console.log(err);
            this.listLoading = false;
            this.applicationList = [];
            this.searchForm.total = 0;
          });
      }
    }
  }
};
</script>
<style lang="scss">

</style>
<style lang="scss" scoped>
.systemUpgrade{
  .tip{
    padding-left: 20px;
    margin-bottom: 20px;
    .info{
      width: 250px;
      display: inline-block;
      font-size: 14px;
      color: #606266;
      font-weight: 700;
    }
  }
}
</style>

